import { useContext, useEffect, useMemo, useState } from 'react'
import { CategoriesContext } from '../../providers/Category'
import { useSelector } from 'react-redux'
import { userSelector } from '../../../store/session'
import { getEstimateFieldCategoryByProject } from '../../../services/estimate-field'

const useCategory = (projectId) => {
  const context = useContext(CategoriesContext)
  const { user } = useSelector(userSelector)

  const [categories, setCategories] = useState([])

  const estimateIds = useMemo(
    () =>
      user?.projects
        ?.filter((project) => (projectId ? project.id == projectId : true))
        .filter((item) => !!item?.estimate?.id)
        .map((item) => item?.estimate?.id),
    [user, projectId, context]
  )

  useEffect(() => {
    if (!context)
      getEstimateFieldCategoryByProject(estimateIds)
        .then((data) => {
          setCategories(data?.data?.map((item) => item.category))
        })
        .catch(() => {
          // TODO: error handling
          setCategories([])
        })
  }, [estimateIds, context])

  return context ? context : [categories]
}

export default useCategory
